<template>
  <div round @click="changeObjetivos()">
    <div class="divImg cursor-pointer">
      <q-img
        v-if="imgObjetivo"
        :src="imgObjetivo"
        :alt="imgObjetivo"
        :class="[objetivoSelected === true ? 'bigObjetivo' : 'littleObjetivo']"
      />
    </div>
    <q-tooltip anchor="top middle" :offset="[0, 30]">
      <strong>{{objetivo.name}}</strong>
    </q-tooltip>

    <DialogWarning
        v-model="showDialog"
        dataCy="delete-indicador"
        :showIcon="true"
        :txtContainer="
          `Los datos introducidos no han sido guardados. Si abandona el proceso sin guardar se perderán todos los cambios.¿Desea salir del indicador?`
        "
        labelDelete="SÍ, SALIR Y PERDER TODOS LOS CAMBIOS"
        labelCancel="NO, PERMANECER EN EL INDICADOR"
        @save="saveChangesObjetivo()"
      />
  </div>
</template>

<script>
import { QImg, QTooltip } from 'quasar';
import Resources from '@/components/shared/mixins/Resources.js';
import DialogWarning from '@/shared/dialogs/warning/DialogWarning.vue';

export default {
  mixins: [Resources],
  components: {
    QImg,
    QTooltip,
    DialogWarning
  },
  props: {
    objetivo: Object,
    objetivoSelected: Boolean,
    form_dirty: Boolean
  },
  computed: {
    imgObjetivo () {
      let res = this.searchResource(this.objetivo.file, 'imagen');
      return res ? res.url : this.getDefaultResource('imagen');
    }
  },
  data () {
    return {
      showDialog: false
    };
  },
  methods: {
    changeObjetivos () {
      if (this.form_dirty) {
        this.showDialog = true;
      } else {
        this.changeDataObjetivoEstrategico();
      }
    },
    closeDialog () {
      this.showDialog = false;
    },
    saveChangesObjetivo () {
      this.$eventHub.$emit('cleanForm');
      this.showDialog = false;
      this.changeDataObjetivoEstrategico();
    },
    changeDataObjetivoEstrategico () {
      this.$store.commit(
        'NGUD/setImgObjetivoEstrategico',
        this.searchResource(this.objetivo.file, 'imagen').url
      );
      this.$emit('updateVisibility', {
        idObj: this.objetivo.id,
        nameObj: this.objetivo.name,
        prefixObj: this.objetivo.prefix,
        colorObj: this.objetivo.color,
        colorHoverObj: this.objetivo.colorHover
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.littleObjetivo,
.divImgLittle {
  height: 55px;
  width: 55px;
}
.q-img:hover,
.bigObjetivo {
  height: 70px;
  width: 70px;
}
.q-btn {
  border: none !important;
}

</style>
